import React, {Fragment} from "react";
import {CalendarPicker} from "views/components/calendar_picker/calendar_picker.component";
import {ModalError} from "views/components/modals/modal_error/modal_error.component";
import {ModalConfirm} from "views/components/modals/modal_confirm/modal_confirm.component";
import {ModalTmpGif} from "views/components/modals/modal_tmp_gif/modal_tmp_gif.component";
import {ModalScoring} from "views/components/modals/modal_scoring/modal_scoring.component";
import {ModalRosterStats} from "views/components/modals/modal_roster_stats/modal_roster_stats.component";
import {ModalSecondaryRegistration} from "views/components/modals/modal_secondary_registration/modal_secondary_registration.component";
import {ModalTomorrowGame} from "views/components/modals/modal_tomorrow_game/modal_tomorrow_game.component";
import {Snackbar} from "views/components/snackbar/snackbar.component";
import {ModalH2hChallenge} from "views/components/modals/modal_h2h_challenge/modal_h2h_challenge.component";
import {ContextualPromptBanners} from "views/components/contextual_prompt_banner/contextual_prompt_banner.component";
import {ModalAcceptTerms} from "views/components/modals/modal_accept_terms/modal_accept_terms.component";

export const Modals = () => (
	<Fragment>
		<CalendarPicker />
		<ModalError />
		<ModalConfirm />
		<ModalTmpGif />
		<ModalScoring />
		<ModalRosterStats />
		<ModalSecondaryRegistration />
		<ModalTomorrowGame />
		<Snackbar />
		<ModalH2hChallenge />
		<ContextualPromptBanners />
		<ModalAcceptTerms />
	</Fragment>
);
